<script>
import TerminalIbansList from "@/components/ipg/elements/TerminalIbansList.vue"
import screenSize from "@/mixins/screenSize.js"

export default {
  name: "ShaparakTerminalsList",
  components: { TerminalIbansList },
  mixins: [screenSize],
  data() {
    return {
      status: false,
      terminalIbans: [],
      terminalId: null,
      isOpenTerminalIbansModal: false,
    }
  },
  computed: {
    shaparakTerminalsList() {
      return this.$store.state.ipg.shaparakTerminals
    },
  },
  watch: {
    isOpenTerminalIbansModal(val) {
      if (val) this.$store.commit("callEditFormModal", true)
      else this.$store.commit("callEditFormModal", false)
    },
  },
  methods: {
    handleManageIbans(terminal) {
      this.isOpenTerminalIbansModal = true
      this.terminalIbans = terminal.ibans
      this.terminalId = terminal.terminal_id
      this.terminalStatus = terminal.status
    },
  },
}
</script>
<template>
  <div>
    <p style="margin: 4px 30px 10px 30px" class="font_35">لیست پایانه‌ها</p>
    <v-card
      color="white"
      style="margin: 4px 30px 30px 30px; border: 1px solid #f5f5f5 !important"
      class="rounded outlined pa-10 pb-5"
      elevation="0"
    >
      <ul
        v-for="(terminal, index) in shaparakTerminalsList"
        :key="terminal.terminal_id"
        class="ticket-details"
        :class="{
          'border-bottom':
            shaparakTerminalsList.length > 1 &&
            index !== shaparakTerminalsList.length - 1,
        }"
      >
        <li class="grid-row">
          <span class="item-label"> شماره پایانه </span>
          <span class="item-value">{{ terminal.terminal_id }}</span>
        </li>
        <li class="grid-row">
          <span class="item-label"> وضعیت </span>
          <span class="item-value">{{ terminal.status_fa }}</span>
        </li>
        <li class="grid-row">
          <span class="item-label"> شماره شبای پیش‌فرض </span>
          <span class="item-value">{{
            terminal.ibans.find((iban) => iban.is_default === 1)?.iban
          }}</span>
        </li>
        <li class="grid-row">
          <span class="item-label"> تاریخ فعال‌سازی </span>
          <span class="item-value">{{
            terminal.activated_at
              ? jalaliDate(terminal.activated_at, "jYYYY/jM/jD - HH:mm")
              : "-"
          }}</span>
        </li>
        <li class="grid-row" style="border-bottom: none">
          <span class="item-label"> تاریخ غیرفعال‌سازی </span>
          <span class="item-value">{{
            terminal.deactivated_at
              ? jalaliDate(terminal.deactivated_at, "jYYYY/jM/jD - HH:mm")
              : "-"
          }}</span>
        </li>
        <v-btn
          dark
          text
          class="btn_small_normal mx-0"
          max-width="100"
          @click="handleManageIbans(terminal)"
        >
          مدیریت شبا
        </v-btn>
      </ul>
    </v-card>
    <v-dialog
      v-model="isOpenTerminalIbansModal"
      :content-class="
        $store.state.addBusinessIbanIsActive
          ? 'secondModal vanmodal'
          : 'vanmodal'
      "
      transition="slide-x-transition"
      :width="reuseIsMobile ? '100%' : '600'"
      no-click-animation
      :fullscreen="reuseIsMobile"
      @click:outside="isOpenTerminalIbansModal = false"
    >
      <TerminalIbansList
        :terminal-id="terminalId"
        @close-modal="isOpenTerminalIbansModal = false"
      />
    </v-dialog>
  </div>
</template>
<style scoped lang="scss">
.ticket-details {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: 12px;
  list-style-type: none;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 12px;
}

li {
  border-bottom: 1px dashed #d5d5d5;
  height: 40px;
  box-sizing: content-box;
}

li:last-child {
  border-bottom: none;
}

.item-label {
  font-size: 11px;
  line-height: 17px;
  color: #999999;
  grid-column: 1;
}

.item-value {
  font-size: 12px;
  line-height: 24px;
  color: #666666;
  grid-column: 2/5;
}

.border-bottom {
  border-bottom: 1px solid #d5d5d5;
}

@media screen and (min-width: 600px) {
  .grid-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: center;
  }
}

@media screen and (max-width: 600px) {
  .grid-row {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 8px 0;
  }
}
</style>
